import { BaseViewStore, BaasicDropdownStore } from "core/stores";
import { action, observable, runInAction } from 'mobx';
import _ from "lodash";
import { uuid } from "core/utils";

class FacilityOrderPatientNewFlowUSIntakePreviewViewStore extends BaseViewStore {
    @observable accessor hospitalClassName = "";
    @observable accessor dischargedClassName = "";
    @observable accessor expiredClassName = "";
    @observable accessor activeClassName = "";
    @observable accessor disabledPatient = false;
    @observable accessor patient = null;
    @observable accessor isQtyChange = false;
    @observable accessor insuranceInfo = "";
    @observable accessor patientNote = "";
    @observable accessor templateExpanded = { id: null, expanded: false };
    @observable accessor productStore;

    inactiveOptions = [{ id: "15", name: "Hospital" }, { id: "17", name: "Discharged" }, { id: "18", name: "Expired" }, { id: "0", name: "Active" }];

    constructor(rootStore, componentsProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.id = componentsProps.id;
        this.facilityOrder = componentsProps.facilityOrder;
        this.facilityOrderPatient = componentsProps.facilityOrderPatient;

        _.forEach(componentsProps.facilityOrderTemplates, (facilityOrderTemplate) => {
            _.forEach(facilityOrderTemplate.facilityOrderTemplateItems, (facilityOrderTemplateItem) => {
                facilityOrderTemplateItem.lastTemplateQuantity = facilityOrderTemplateItem.templateQuantity;
                facilityOrderTemplateItem.lastOrderQuantity = facilityOrderTemplateItem.orderQuantity;
                facilityOrderTemplateItem.lastNote = facilityOrderTemplateItem.note;
            });
        });

        this.facilityOrderTemplates = componentsProps.facilityOrderTemplates;
        this.patient = componentsProps.facilityOrderPatient.patient;
        this.isMasterPatient = this.facilityOrder.facility.masterPatientId == this.patient.patientKey;
        this.lookups = componentsProps.lookups;
        this.pageViewStore = componentsProps.pageViewStore;
        this.sendAgoraPo = this.facilityOrder.facility.sendAgoraPo;

        if (this.facilityOrderTemplates && this.facilityOrderTemplates.some(i => i.templateId)) {
            this.oldTemplate = this.facilityOrderTemplates.filter(i => i.templateId)[0];
        }

        this.selectedStatusAbrv = componentsProps.selectedStatusAbrv;
        this.inactiveOptionStore = new BaasicDropdownStore(
            {
                multi: false,
                filterable: false,
            },
            {
                fetchFunc: () => {
                    return this.inactiveOptions;
                },
            }
        );

        document.addEventListener('click', (e) => {
            if (!this.templateExpanded.id) return;
            const elements = [
                ...document.querySelectorAll(`[id="templateQuantity-${this.templateExpanded.id}"]`),
                ...document.querySelectorAll(`[id="orderQuantity-${this.templateExpanded.id}"]`),
            ];
            const clickedOutside = elements.length === 0 || elements.every((el) => !el.contains(e.target));
            if (clickedOutside) {
                this.templateExpanded.expanded = false;
            }
        });

        this.fetch([this.initialize()]);
    }

    @action.bound
    async initialize() {
        this.getPatientStatusButtonClassName();
        this.insuranceInfo = this.facilityOrderPatient && this.facilityOrderPatient.insuranceInfo;
        this.patientNote = this.facilityOrderPatient && this.facilityOrderPatient.note;
    }

    @action.bound
    getPatientStatusButtonClassName(inactiveOptionId = null) {
        this.hospitalClassName = "";
        this.dischargedClassName = "";
        this.expiredClassName = "";
        this.activeClassName = "";
        this.inactiveOptionStoreId = "";

        this.inactiveOptions
            .filter((i) => !inactiveOptionId || i.id === inactiveOptionId)
            .forEach((item) => {
                if (this.selectedStatusAbrv === "in-progress") {
                    if (item.name === "Hospital" && this.facilityOrderPatient.activeStatus === 'Hospital') {
                        this.hospitalClassName = "is-active--alt";
                    }
                    else if (item.name === "Active" && this.facilityOrderPatient.activeStatus !== 'Hospital') {
                        this.inactiveOptionStoreId = "0";
                        this.activeClassName = "is-active";
                    }
                }
                else if (this.selectedStatusAbrv === "new-order" || this.selectedStatusAbrv === "change" || this.selectedStatusAbrv === "no-change") {
                    if (item.name === "Active") {
                        this.inactiveOptionStoreId = "0";
                        this.activeClassName = "is-active";
                    }
                }
                else if (this.selectedStatusAbrv === "discharge") {
                    if (item.name === "Hospital" && this.facilityOrderPatient.activeStatus === "Hospital") {
                        this.inactiveOptionStoreId = "15";
                        this.hospitalClassName = "is-active";
                    }
                    else if (item.name === "Discharged" && this.facilityOrderPatient.activeStatus === "Discharged") {
                        this.inactiveOptionStoreId = "17";
                        this.dischargedClassName = "is-active";
                    }
                    else if (item.name === "Expired" && this.facilityOrderPatient.activeStatus === "Expired") {
                        this.inactiveOptionStoreId = "18";
                        this.expiredClassName = "is-active";
                    }
                    else if (item.name === "Active" && this.facilityOrderPatient.activeStatus !== "Hospital" && this.facilityOrderPatient.activeStatus !== "Discharged" && this.facilityOrderPatient.activeStatus !== "Expired") {
                        this.inactiveOptionStoreId = "0";
                        this.activeClassName = "is-active";
                    }
                }
                else if (this.selectedStatusAbrv === "intake-reviewed") {
                    if (item.name === "Active") {
                        this.inactiveOptionStoreId = "0";
                        this.activeClassName = "is-active";
                    }
                }
            });
    }

    @action.bound
    openExtraSuppliesApprovalRequiredModal(master) {
        if (master && this.facilityOrder.facility.corporate_ && this.facilityOrder.facility.corporate_.approvalRequiredExtraSupplies) {
            this.pageViewStore.extraSuppliesApprovalRequiredModal.onConfirm = async () => { this.pageViewStore.extraSuppliesApprovalRequiredModal.close(); await this.openCreateFacilityOrderTemplateUSIntakeNewFlowModal(); };

            this.pageViewStore.extraSuppliesApprovalRequiredModal.open({
                question: 'MODAL.QUESTION_EXTRA_SUPPLIES_APPROVAL'
            });
        }
        else {
            this.openCreateFacilityOrderTemplateUSIntakeNewFlowModal();
        }
    }

    @action.bound
    async openCreateFacilityOrderTemplateUSIntakeNewFlowModal() {
        const inactiveOption = this.getSelectedInactiveOption("insurance");
        const newFlowInsuranceStatusId = inactiveOption == "success" ? this.lookups.newFlowStatus.find((s) => s.abrv === "no-change").id : inactiveOption == "change" ? this.lookups.newFlowStatus.find((s) => s.abrv === "change").id : null;
        await this.pageViewStore.createFacilityOrderTemplateUSIntakeNewFlowModal.open({
            facilityOrderId: this.facilityOrder.id,
            patientId: this.patient.id,
            patientKey: this.patient.patientKey,
            patient: this.patient,
            facilityOrder: this.facilityOrder,
            newFlowInsuranceStatusId: newFlowInsuranceStatusId,
            isReviewed: this.selectedStatusAbrv === "intake-reviewed",
            isClinicalReviewed: (!this.facilityOrderPatient.eligibilityStatus || (this.facilityOrderPatient.eligibilityStatus && this.facilityOrderPatient.eligibilityStatus.name !== "Eligible")) && this.selectedStatusAbrv === "intake-reviewed",
            fetchPatientTemplates: () => this.pageViewStore.fetchFacilityOrderTemplatesByPatient(this.facilityOrderPatient.patientId)
        });
    }

    @action.bound
    getSelectedInactiveOption(option, facilityOrderTemplate) {
        if (option === "intake" && facilityOrderTemplate) {
            if (facilityOrderTemplate.newFlowStatusId === this.pageViewStore.changeNewFlowStatusId) {
                return "warning-triangle";
            }
            else if (facilityOrderTemplate.newFlowStatusId === this.pageViewStore.noChangeNewFlowStatusId) {
                return "success";
            }
            else if (facilityOrderTemplate.newFlowStatusId === this.pageViewStore.dischargeNewFlowStatusId && this.facilityOrderTemplates) {
                return "danger";
            }
        }
        else if (option === "insurance") {
            if (this.facilityOrderTemplates.every((x) => x.newFlowInsuranceStatusId === this.pageViewStore.noChangeNewFlowStatusId)) {
                return "success";
            }
            else if (this.facilityOrderTemplates.every((x) => x.newFlowInsuranceStatusId === this.pageViewStore.changeNewFlowStatusId)) {
                return "change";
            }
        }
        else if (option === "us-intake" && facilityOrderTemplate) {
            if ((!facilityOrderTemplate.templateId || (facilityOrderTemplate.newFlowStatusId === this.pageViewStore.newOrderNewFlowStatusId && (facilityOrderTemplate.importDetailStatusId === this.pageViewStore.importedImportDetailStatusId || facilityOrderTemplate.importDetailStatusId === this.pageViewStore.failedImportDetailStatusId))) && (facilityOrderTemplate.inactiveReasonId != 15 && facilityOrderTemplate.inactiveReasonId != 17 && facilityOrderTemplate.inactiveReasonId != 18)) {
                return "new";
            }
            else if (facilityOrderTemplate.newFlowStatusId === this.pageViewStore.changeNewFlowStatusId) {
                return "warning-triangle";
            }
            else if (facilityOrderTemplate.newFlowStatusId === this.pageViewStore.noChangeNewFlowStatusId) {
                return "success";
            }
            else if (facilityOrderTemplate.newFlowStatusId === this.pageViewStore.dischargeNewFlowStatusId && this.facilityOrderTemplates) {
                return "danger";
            }
        }
        return "";
    }

    @action.bound
    async openFacilityOrderTemplateItemNewFlowActivatePatientModal(inactiveOptionId) {
        this.disabledPatient = true;
        if (inactiveOptionId === "0") {
            if (this.pageViewStore.facilityOrderStatus && this.pageViewStore.facilityOrderStatus.completedOn) {
                await this.activatePatient();
            }
            else {
                await this.setPatientStatus(inactiveOptionId === "15" ? "Hospital" : inactiveOptionId === "17" ? "Discharged" : inactiveOptionId === "18" ? "Expired" : "Active");
                await this.setInactiveOption("in-progress", inactiveOptionId);
            }
        }
        else {
            await this.setPatientStatus(inactiveOptionId === "15" ? "Hospital" : inactiveOptionId === "17" ? "Discharged" : inactiveOptionId === "18" ? "Expired" : "Active");
            await this.setInactiveOption("discharge", inactiveOptionId, true);
        }
        this.disabledPatient = false;
    }

    @action.bound
    async activatePatient() {
        if (this.facilityOrderPatient.eligibilityStatusId && this.facilityOrderPatient.isReviewed) {
            await this.pageViewStore.facilityOrderTemplateService.activateFacilityOrderTemplate({ facilityOrderPatientId: this.facilityOrderPatient.id, eligibilityStatusId: this.facilityOrderPatient.eligibilityStatusId });
            await this.setPatientStatus("Active");
            await this.pageViewStore.fetchFacilityOrderTemplatesByPatient(this.facilityOrderPatient.patientId);
        }
        else {
            await this.openFacilityOrderTemplateNewFlowUSIntakePatientActivationModal();
        }
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakePatientActivationModal() {
        this.pageViewStore.facilityOrderTemplateNewFlowUSIntakeTemplateActivationModal.open({
            facilityOrderPatient: this.facilityOrderPatient,
            patient: this.patient,
            setPatientStatus: async () => await this.setPatientStatus("Active"),
            fetchPatientTemplates: () => this.pageViewStore.fetchFacilityOrderTemplatesByPatient(this.facilityOrderPatient.patientId, false, true)
        });
    }

    @action.bound
    async setPatientStatus(status) {
        this.facilityOrderPatient.activeStatus = status;
        await this.pageViewStore.facilityOrderPatientService.update(this.facilityOrderPatient);
    }

    @action.bound
    async setInactiveOption(newFlowStatusAbrv, inactiveOptionId, showDischarges = false) {
        _.each(this.facilityOrderTemplates, (item) => {
            item.inactiveReasonId = inactiveOptionId;
            item.inactiveReason = this.inactiveOptions.find((i) => i.id === inactiveOptionId).name;
        });
        await this.saveInactiveReason(newFlowStatusAbrv, inactiveOptionId, showDischarges);
    }

    @action.bound
    async saveInactiveReason(statusAbrv, inactiveOptionId, showDischarges = false) {
        try {
            const status = this.lookups.newFlowStatus.find((s) => s.abrv === statusAbrv);
            const updatedItems = _.map(this.facilityOrderTemplates, (item) => {
                return {
                    id: item.id,
                    inactiveReasonId: inactiveOptionId,
                    isReviewed: statusAbrv === "in-progress" ? false : item.isReviewed,
                    newFlowStatusId: statusAbrv === "intake-reviewed" ? item.newFlowStatusId : status.id,
                    newFlowStatusUpdatedByUserId: this.rootStore.userStore.user.id,
                    newFlowInsuranceStatusId: statusAbrv === "discharge" ? status.id : statusAbrv === "intake-reviewed" ? item.newFlowInsuranceStatusId : status.id,
                    portalNote: item.portalNote,
                    setInitialEligibility: item.setInitialEligibility,
                    newFlowUSIntakeStatusId: status.id,
                    setInactiveReason: true,
                    isTemplateStatus: false,
                    setStatuses: true,
                    setInsuranceStatus: false
                };
            });
            await this.pageViewStore.facilityOrderTemplateService.batchUpdate(updatedItems);
            await this.pageViewStore.fetchFacilityOrderTemplatesByPatient(this.facilityOrderPatient.patientId, showDischarges);
        }
        catch (err) {
            this.rootStore.notificationStore.error("An unexpected error occurred while trying to update the template.", err);
        }
    }

    @action.bound
    showPreviousFlag() {
        return this.facilityOrderPatient && this.facilityOrderPatient.facilityOrderPatientInitial && (this.facilityOrderPatient.activeStatus != this.facilityOrderPatient.facilityOrderPatientInitial.activeStatus);
    }

    @action.bound
    async reviewTemplates(facilityOrderTemplateId) {
        this.disabledPatient = true;
        await this.reviewActiveTemplates("intake-reviewed", facilityOrderTemplateId, true);
        this.disabledPatient = false;
    }

    @action.bound
    async reviewActiveTemplates(statusAbrv, templateId, isReview) {
        try {
            const status = this.lookups.newFlowStatus.find((s) => s.abrv === statusAbrv);
            const updatedItems = _.map(this.facilityOrderTemplates.filter((item) => !templateId || item.id === templateId), (item) => {
                return {
                    id: item.id,
                    inactiveReasonId: item.inactiveReasonId,
                    isReviewed: !isReview ? false : (isReview && templateId ? isReview : (isReview ? (item.newFlowUSIntakeStatusId === this.pageViewStore.noChangeNewFlowStatusId ? true : false) : item.isReviewed)),
                    newFlowStatusId: item.newFlowStatusId,
                    newFlowStatusUpdatedByUserId: this.rootStore.userStore.user.id,
                    newFlowInsuranceStatusId: statusAbrv === "intake-reviewed" || templateId ? item.newFlowInsuranceStatusId : status.id,
                    portalNote: item.portalNote,
                    newFlowUSIntakeStatusId: !isReview ? item.newFlowStatusId : (isReview && !templateId ? (item.newFlowUSIntakeStatusId === this.pageViewStore.noChangeNewFlowStatusId ? status.id : item.newFlowUSIntakeStatusId) : status.id),
                    changeTemplateStatus: isReview && (item.newFlowStatusId == this.pageViewStore.inProgressNewFlowStatusId || item.newFlowStatusId == this.pageViewStore.changeNewFlowStatusId)
                };
            });

            this.pageViewStore.removeFacilityOrderTemplatesByPatient(this.facilityOrderPatient.patientId, templateId, isReview);
            await this.pageViewStore.facilityOrderTemplateService.batchUpdate(updatedItems);
            if (isReview) {
                this.pageViewStore.fullReviewCheck(true);
            }
        }
        catch (err) {
            this.rootStore.notificationStore.error("An unexpected error occurred while trying to update the template.");
        }
    }

    @action.bound
    async reviewDischargeTemplates(facilityOrderTemplateId) {
        this.disabledPatient = true;
        await this.saveTemplates(facilityOrderTemplateId, true);
        this.disabledPatient = false;
    }

    @action.bound
    async saveTemplates(facilityOrderTemplateId, isReviewed) {
        let updateItems = this.facilityOrderTemplates.filter((item) => !facilityOrderTemplateId || item.id === facilityOrderTemplateId);
        updateItems.forEach(item => {
            item.isReviewed = isReviewed;
        });
        await this.pageViewStore.facilityOrderTemplateService.batchUpdate(updateItems);
        await this.pageViewStore.checkIsReviewedTemplateStatusChange();
    }

    @action.bound
    async setInsuranceStatus(newFlowStatusAbrv, isStatus = false) {
        if (newFlowStatusAbrv === "no-change") {
            await this.setNewFlowStatus(newFlowStatusAbrv, null, null, "insurance");
        } else if (newFlowStatusAbrv === "change") {
            await this.openFacilityOrderPatientNewFlowInsuranceNoteModal(newFlowStatusAbrv, isStatus);
        }
    }

    @action.bound
    async setNewFlowStatus(
        statusAbrv,
        templateId,
        inactiveOptionId = null,
        role = null,
        setInactiveReason = false,
        setStatuses = false,
        changeFacilityOrderPatientInsuranceStatus = false,
        changeFacilityOrderTemplateStatus = false
    ) {
        this.disabledPatient = true;
        try {
            const status = this.lookups.newFlowStatus.find((s) => s.abrv === statusAbrv);
            let updateItems = this.facilityOrderTemplates.filter((item) => !templateId || item.id === templateId);

            const updatedItems = _.map(updateItems, (item) => {
                return {
                    id: item.id,
                    inactiveReasonId: statusAbrv === "discharge" && templateId ? 58 : inactiveOptionId != null ? inactiveOptionId : item.inactiveReasonId,
                    isReviewed: item.isReviewed,
                    newFlowStatusId: statusAbrv === "intake-reviewed" || role == "insurance" ? item.newFlowStatusId : status.id,
                    newFlowStatusUpdatedByUserId: this.rootStore.userStore.user.id,
                    newFlowInsuranceStatusId: statusAbrv === "discharge" ? status.id : statusAbrv === "intake-reviewed" || role == "intake" || templateId ? item.newFlowInsuranceStatusId : status.id,
                    portalNote: item.portalNote,
                    setInitialEligibility: item.setInitialEligibility,
                    newFlowUSIntakeStatusId: role === "insurance" ? item.newFlowUSIntakeStatusId : status.id,
                    setInactiveReason: setInactiveReason,
                    isTemplateStatus: templateId ? true : false,
                    setStatuses: setStatuses && !templateId ? true : false,
                    setInsuranceStatus: this.selectedStatusAbrv === "discharge" && statusAbrv !== "discharge" && templateId ? true : false
                };
            });

            await this.pageViewStore.facilityOrderTemplateService.batchUpdate(updatedItems);

            if (changeFacilityOrderPatientInsuranceStatus) {
                await this.pageViewStore.facilityOrderPatientService.changeFacilityOrderPatientInsuranceStatus({ id: this.facilityOrderPatient.id });
            }

            if (changeFacilityOrderTemplateStatus) {
                await this.pageViewStore.facilityOrderTemplateService.changeTemplateStatus(updateItems.map(item => item.id));
            }

            await this.pageViewStore.fetchFacilityOrderTemplatesByPatient(this.facilityOrderPatient.patientId, true, true);
        }
        catch (err) {
            this.rootStore.notificationStore.error("An unexpected error occurred while trying to update the template.", err);
        }
        this.disabledPatient = false;
    }

    @action.bound
    async openFacilityOrderPatientNewFlowInsuranceNoteModal(newFlowStatusAbrv, isStatus = false) {
        this.pageViewStore.facilityOrderPatientNewFlowInsuranceNoteModal.open({
            facilityOrderPatient: this.facilityOrderPatient,
            facilityOrderId: this.facilityOrder.id,
            patient: this.patient,
            facilityOrderTemplates: this.facilityOrderTemplates,
            setNewFlowStatus: async (changeFacilityOrderTemplateStatus) => await this.setNewFlowStatus(newFlowStatusAbrv, null, null, isStatus ? "insurance" : null, true, false, true, changeFacilityOrderTemplateStatus),
            // Reload the local patient (insurance) and the facility order patient so the backend-recomputed
            // "No OON Benefits" eligibility status note is displayed after the primary active insurance changes.
            refreshInsuranceData: async () => {
                await this.fetchPatient();
                await this.reloadFacilityOrderPatientNote();
            },
            fetchPatientTemplates: async () => await this.pageViewStore.fetchFacilityOrderTemplatesByPatient(this.facilityOrderPatient.patientId, false, true),
            changeFacilityOrderPatientInsuranceStatus: () => this.changeFacilityOrderPatientInsuranceStatus(),
            showTemplateChangeWarning: (facilityOrderTemplate, checkEligibilityStatusChange, isEligibilityCheck, checkNonEligibilityStatusChange, isParUpdated) => this.showTemplateChangeWarning(facilityOrderTemplate, checkEligibilityStatusChange, isEligibilityCheck, checkNonEligibilityStatusChange, isParUpdated)
        });
    }

    @action.bound
    async fetchPatient() {
        if (this.patient) {
            let response = await this.pageViewStore.localPatientService.get(this.patient.id);
            this.patient = response.data;
            this.facilityOrderPatient.patient = response.data;
        }
    }

    @action.bound
    async reloadFacilityOrderPatientNote() {
        // Reload this store's own facilityOrderPatient in place (not the page-level array) so the object the
        // Eligibility Status Note modal reads reflects the backend-recomputed note.
        let response = (await this.pageViewStore.facilityOrderPatientService.find({ rpp: 1, facilityOrderId: this.facilityOrder.id, patientId: this.facilityOrderPatient.patientId, embed: "EligibilityStatus,FacilityOrderPatientInitial,FacilityOrderPatientInitial.EligibilityStatus,Patient" })).data.item;
        if (response && response[0]) {
            Object.keys(this.facilityOrderPatient).forEach(key => {
                this.facilityOrderPatient[key] = response[0][key];
            });
        }
    }

    @action.bound
    async openFacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal() {
        this.pageViewStore.facilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal.open({
            facilityOrderPatient: this.facilityOrderPatient
        });
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal() {
        this.pageViewStore.facilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal.open({
            patient: this.patient,
            facilityOrderPatient: this.facilityOrderPatient,
            showTemplateChangeWarning: () => this.showTemplateChangeWarning()
        });
    }

    @action.bound
    showTemplateChangeWarning(
        facilityOrderTemplate,
        checkEligibilityStatusChange,
        isEligibilityCheck = false,
        checkNonEligibilityStatusChange = false,
        isParUpdated = false
    ) {
        if (isParUpdated) {
            this.pageViewStore.templateChangeConfirmModal.open({
                message: "PAR flag was updated on a clinically reviewed template. Please ensure that the change you made is accounted for."
            });
            return;
        }

        let clinicalReviewFacilityOrderStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'clinical-review');
        if (isEligibilityCheck && checkNonEligibilityStatusChange && clinicalReviewFacilityOrderStatus && clinicalReviewFacilityOrderStatus.completedOn) {
            this.pageViewStore.templateChangeConfirmModal.open({
                message: "Clinical review has been completed. Please ensure that the change you made is accounted for."
            });
            return;
        }

        if (!(this.facilityOrderPatient.activeStatus === "Active" && this.facilityOrderPatient.eligibilityStatus && this.facilityOrderPatient.eligibilityStatus.name === "Eligible")) {
            return;
        }

        if (isEligibilityCheck) {
            if (!facilityOrderTemplate && checkEligibilityStatusChange && this.facilityOrderTemplates.find(x => x.isClinicalReviewed)) {
                this.pageViewStore.templateChangeConfirmModal.open({
                    message: "At least one of this patient's templates has already been reviewed by Clinical Review. Please ensure that the change you made is accounted for."
                });
                return;
            }
        }
        else {
            if (facilityOrderTemplate && facilityOrderTemplate.isClinicalReviewed) {
                this.pageViewStore.templateChangeConfirmModal.open({
                    message: "This template has already been reviewed by Clinical Review. Please ensure that the change you made is accounted for."
                });
                return;
            }

            if (!facilityOrderTemplate && this.facilityOrderTemplates.find(x => x.isClinicalReviewed)) {
                this.pageViewStore.templateChangeConfirmModal.open({
                    message: "At least one of this patient's templates has already been reviewed by Clinical Review. Please ensure that the change you made is accounted for."
                });
            }
        }
    }

    @action.bound
    async openFacilityOrderPatientNewFlowInsuranceEditModal() {
        this.pageViewStore.facilityOrderPatientNewFlowInsuranceEditModal.open({
            patient: this.patient,
            refreshInsuranceData: async () => await this.pageViewStore.fetchFacilityOrderTemplatesByPatient(this.facilityOrderPatient.patientId, undefined, true),
            changeFacilityOrderPatientInsuranceStatus: () => this.changeFacilityOrderPatientInsuranceStatus(),
            facilityOrderPatient: this.facilityOrderPatient,
            facilityOrderTemplates: this.facilityOrderTemplates
        });
    }

    @action.bound
    async openFacilityOrderPatientNewFlowUSIntakeInsuranceInfoModal() {
        this.pageViewStore.facilityOrderPatientNewFlowUSIntakeInsuranceInfoModal.open({
            facilityOrderPatient: this.facilityOrderPatient,
            updateFacilityOrderPatient: () => this.updateFacilityOrderPatient(),
            changeInsuranceInfo: async (insuranceInfo) => {
                this.changeInsuranceInfo(insuranceInfo);
                // Reload the facility order patient so the backend-recomputed "Non-Billable Insurance" eligibility
                // status note is displayed after the modal saves the Insurance Info Note.
                await this.reloadFacilityOrderPatientNote();
            }
        });
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal() {
        this.pageViewStore.facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal.open({
            patient: this.patient,
            facilityOrderTemplates: this.facilityOrderTemplates,
            facilityOrderPatient: this.facilityOrderPatient
        });
    }

    @action.bound
    async openInsuranceInformation() {
        window.open(`${this.rootStore.applicationStore.app.baasic.settings.brightreeBaseUrl}Patient/frmPatientInsuranceRO.aspx?PatientKey=${this.patient.patientKey}&Edit=0`);
    }

    @action.bound
    async reviewPatient() {
        this.disabledPatient = true;
        this.facilityOrderPatient.isReviewed = !this.facilityOrderPatient.isReviewed;
        await this.updateFacilityOrderPatient();
        await this.changeFacilityOrderPatientInsuranceStatus(true);
        this.disabledPatient = false;
    }

    @action.bound
    async updateFacilityOrderPatient(isInsuranceInfo) {
        if (isInsuranceInfo) {
            this.facilityOrderPatient.insuranceInfo = this.insuranceInfo;
        }
        await this.pageViewStore.facilityOrderPatientService.update(this.facilityOrderPatient);
        if (isInsuranceInfo) {
            // Reload the facility order patient so the backend-recomputed "Non-Billable Insurance" eligibility
            // status note is displayed after the Insurance Info Note is saved.
            await this.reloadFacilityOrderPatientNote();
        }
    }

    async changeFacilityOrderPatientInsuranceStatus(insuranceReview = false) {
        if (this.selectedStatusAbrv !== "discharge" && !this.facilityOrderPatient.isNewPatient) {
            let response = await this.pageViewStore.facilityOrderPatientService.changeFacilityOrderPatientInsuranceStatus({ id: this.facilityOrderPatient.id, insuranceReview: insuranceReview });
            if (response && response.data && response.data.item && this.facilityOrderTemplates.length > 0) {
                for (const item of response.data.item) {
                    if (this.facilityOrderTemplates.find(x => x.id === item.id)) {
                        this.facilityOrderTemplates.find(x => x.id === item.id).newFlowInsuranceStatusId = item.newFlowInsuranceStatusId;
                        this.facilityOrderTemplates.find(x => x.id === item.id).newFlowInsuranceStatus = this.lookups.newFlowStatus.find((s) => s.id === item.newFlowInsuranceStatusId);
                    }
                }
            }
        }
    }

    @action.bound
    changeInsuranceInfo(insuranceInfo) {
        this.insuranceInfo = insuranceInfo;
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal(facilityOrderTemplate) {
        if (!facilityOrderTemplate.missingProduct) {
            await this.pageViewStore.facilityOrderTemplateService.updateMissingProduct({
                id: facilityOrderTemplate.id
            });
            facilityOrderTemplate.missingProduct = true;
        }

        this.pageViewStore.facilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal.open({
            facilityOrderTemplate: facilityOrderTemplate,
            showTemplateChangeWarning: () => this.showTemplateChangeWarning(facilityOrderTemplate)
        });
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowInvoiceNoteModal(facilityOrderTemplate) {
        this.pageViewStore.facilityOrderTemplateNewFlowInvoiceNoteModal.open({
            facilityOrderTemplate: facilityOrderTemplate
        });
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakePortalNoteModal(facilityOrderTemplate) {
        this.pageViewStore.facilityOrderTemplateNewFlowUSIntakePortalNoteModal.open({
            facilityOrderTemplateId: facilityOrderTemplate.id,
            refreshPortalNote: (portalNote) => (facilityOrderTemplate.portalNote = portalNote),
            isIntakeReviewed: this.selectedStatusAbrv === "intake-reviewed"
        });
    }

    @action.bound
    async openFacilityOrderTemplateDoNotSupplyModal(facilityOrderTemplate) {
        this.pageViewStore.facilityOrderTemplateDoNotSupplyModal.open({
            title: `${facilityOrderTemplate.inactiveReasonId == 16 ? "Unmark" : "Mark"} As Do Not Supply`,
            description: `Are you sure you want to ${facilityOrderTemplate.inactiveReasonId == 16 ? "unmark" : "mark"} this order as Do not supply?`,
            markDoNotSupply: () => this.markDoNotSupply(facilityOrderTemplate),
            showTemplateChangeWarning: () => this.showTemplateChangeWarning(facilityOrderTemplate)
        });
    }

    @action.bound
    async markDoNotSupply(facilityOrderTemplate) {
        await this.pageViewStore.facilityOrderTemplateService.setDoNotSupply(facilityOrderTemplate);
        facilityOrderTemplate.inactiveReasonId = facilityOrderTemplate.inactiveReasonId == 16 ? 0 : 16;
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakeClinicalInformationModal(facilityOrderTemplate, disabledSendOrder) {
        this.pageViewStore.facilityOrderTemplateNewFlowUSIntakeClinicalInformationModal.open({
            facilityOrderTemplate: facilityOrderTemplate,
            facilityOrderPatient: this.facilityOrderPatient,
            facilityOrder: this.facilityOrder,
            isUSIntakeNewFlow: true,
            patient: this.patient,
            lookups: this.lookups,
            isEligible: this.facilityOrderPatient.eligibilityStatus && this.facilityOrderPatient.eligibilityStatus.name === "Eligible",
            setDifferentQty: () => this.setDifferentQty(facilityOrderTemplate, "IsDifferentQty,IsDoNotSupply"),
            setIsQtyChange: () => { this.isQtyChange = true; this.isQtyChange = false; },
            disabled: disabledSendOrder
        });
    }

    @action.bound
    async setDifferentQty(facilityOrderTemplate, embed) {
        const response = await this.pageViewStore.facilityOrderTemplateService.getFacilityOrderTemplateValidation(facilityOrderTemplate.id, { embed: embed });
        runInAction(() => {
            if (response && response.data && embed) {
                if (embed.includes('IsDoNotSupply')) {
                    facilityOrderTemplate.isDoNotSupply = response.data.isDoNotSupply;
                }
                if (embed.includes('IsDifferentQty')) {
                    facilityOrderTemplate.isDifferentQty = response.data.isDifferentQty;
                }
            }
        });
    }

    @action.bound
    async setTemplateStatus(
        newFlowStatusAbrv,
        facilityOrderTemplateId,
        inactiveReasonId = null,
        setInactiveReason = false
    ) {
        await this.setNewFlowStatus(newFlowStatusAbrv, facilityOrderTemplateId, inactiveReasonId, "intake", setInactiveReason);
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowDeleteModal(facilityOrderTemplateId) {
        let item = this.facilityOrderTemplates.find(i => i.id === facilityOrderTemplateId)

        let params = { facilityOrderId: this.facilityOrder.id, patientId: item.patientId};
        var response = (await this.pageViewStore.facilityOrderTemplateService.find(params)).data.item;

        this.pageViewStore.facilityOrderTemplateNewFlowDeleteModal.open({
            item: item,
            deleteTemplate: () => this.deleteTemplate(facilityOrderTemplateId),
            numberOfTemplates: response.length,
            isNewPatient: this.facilityOrderPatient.isNewPatient
        });
    }

    @action.bound
    async deleteTemplate(facilityOrderTemplateId) {
        const skipEnabling = this.disabledPatient;
        this.disabledPatient = true;
        try {
            await this.pageViewStore.facilityOrderTemplateService.deleteNewTemplate(facilityOrderTemplateId);
            await this.pageViewStore.fetchFacilityOrderTemplatesByPatient(this.facilityOrderPatient.patientId, true);
        } catch (err) {
            this.rootStore.notificationStore.error("Error occurred while trying to delete a template.");
        }
        if (!skipEnabling) {
            this.disabledPatient = false;
        }
    }

    @action.bound
    async unreviewTemplate(facilityOrderTemplateId) {
        this.disabledPatient = true;
        await this.reviewActiveTemplates("in-progress", facilityOrderTemplateId, false);
        this.disabledPatient = false;
    }

    @action.bound
    isDisabledTemplateReview() {
        if (this.facilityOrderTemplates.some(x => x.newFlowInsuranceStatusId === this.pageViewStore.inProgressNewFlowStatusId) ||
            ((this.facilityOrderPatient.isNewPatient || this.facilityOrderTemplates.every(x => x.newFlowInsuranceStatusId === this.pageViewStore.changeNewFlowStatusId)) && !this.facilityOrderPatient.isReviewed)) {
            return true;
        }
        return false;
    }

    @action.bound
    async updatePortalNote(id, portalNote) {
        await this.pageViewStore.facilityOrderTemplateService.updatePortalNote({ id, portalNote });
    }

    @action.bound
    showItemQuantities(facilityOrderTemplate, show) {
        this.templateExpanded = { id: facilityOrderTemplate.id, expanded: show }
    }

    @action.bound
    async addEmptyItem(facilityOrderTemplateId) {
        const facilityOrderTemplate = this.facilityOrderTemplates.find( item => item.id === facilityOrderTemplateId);
        if (facilityOrderTemplate.facilityOrderTemplateItems && facilityOrderTemplate.facilityOrderTemplateItems.some(i => !i.productId)) {
            return;
        }

        await this.setProductStore(facilityOrderTemplate.subCategoryId);

        facilityOrderTemplate.facilityOrderTemplateItems.push({
            id: uuid(),
            note: null,
            product: null,
            productId: null,
            procedureCode: null,
            mlph: undefined,
            frequency: undefined,
            itemCals: 0,
            itemMls: 0,
            templateQuantity: null,
            orderQuantity: 0,
            importActionId: this.lookups.importAction.find(x => x.abrv === 'insert').id,
            importDetailStatusId: this.lookups.importDetailStatus.find(x => x.abrv === 'new').id,
            facilityOrderTemplateId: facilityOrderTemplateId,
            toggle: true
        });
    }

    @action.bound
    setItemToggle(facilityOrderTemplateItem) {
        facilityOrderTemplateItem.toggle = false;
    }

    @action.bound
    async setProductStore(subCategoryId) {
        const ostomySubCategory = this.lookups.subCategory.find((x) => x.abrv == "Ostomy-Products");
        const isOstomySubCategory = subCategoryId === ostomySubCategory.id;

        this.productStore = new BaasicDropdownStore(
            {
                filterable: true,
                textField: "itemId",
            },
            {
                fetchFunc: async (term) => {
                    if ((term && term.trim()) === '')
                        term = undefined;

                    let params = {
                        searchQuery: term,
                        rpp: 50,
                        subCategoryId: subCategoryId,
                        isActive: true,
                        embed: "Product,Product.ItemType,Product.ItemCategory,Product.SubCategory,Product.UnitOfMeasure,Product.ProcedureCode_",
                    };

                    if (isOstomySubCategory) {
                        params = { ...params, sort: "isPreferred|desc" };
                    }

                    const response = await this.pageViewStore.itemSubcategoryService.find(params);
                    let filteredProducts = this.isMasterPatient ? response.data.item : response.data.item.filter((x) => !x.product.itemId.toLowerCase().includes("-cs"));

                    return _.map(filteredProducts, (item) => { return { ...item.product }; });
                },
            }
        );
    }

    @action.bound
    async saveItemOnProductSelect(
        facilityOrderTemplateItem,
        facilityOrderTemplateItems,
        index,
        product,
        facilityOrderTemplate
    ) {
        this.disabledPatient = true;
        try {
            const trachTubeSubCategoryId = this.lookups.subCategory.find(x => x.abrv == 'Trach-Tube').id;
            if (facilityOrderTemplate.templateId && facilityOrderTemplate.subCategoryId === trachTubeSubCategoryId && facilityOrderTemplateItems.some(x => x.productId && x.importActionId !== this.pageViewStore.deleteImportActionId)) {
                this.rootStore.modalStore.showConfirm('FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_DELTE_TRACH_TUBE_ITEMS', async () => {
                    await this.saveItem(facilityOrderTemplateItem, facilityOrderTemplateItems, index, product, facilityOrderTemplate, true);
                    this.changeFacilityOrderTemplateStatus([facilityOrderTemplate.id]);
                });
            }
            else {
                await this.saveItem(facilityOrderTemplateItem, facilityOrderTemplateItems, index, product, facilityOrderTemplate);
                this.changeFacilityOrderTemplateStatus([facilityOrderTemplate.id]);
            }

        } catch (err) {
            this.rootStore.notificationStore.error(err.data ? err.data : "FACILITY_ORDER_TEMPLATE_ITEM.EDIT.ERROR");
        }
        this.disabledPatient = false;
    }

    @action.bound
    async saveItem(
        facilityOrderTemplateItem,
        facilityOrderTemplateItems,
        index,
        product,
        facilityOrderTemplate,
        refreshTemplates = false
    ) {
        if (product) {
            let tempItem = {
                product: product,
                productId: product.id,
                procedureCode: product.procedureCode_ && product.procedureCode_.abrv,
                importActionId: facilityOrderTemplateItem.importActionId,
                importDetailStatusId: facilityOrderTemplateItem.importDetailStatusId,
                facilityOrderTemplateId: facilityOrderTemplate.id,
            };

            const isEnteral = facilityOrderTemplate.itemCategoryId == this.pageViewStore.enteralItemCategoryId;
            const itemType = product.itemTypeId || (product.procedureCode_ && product.procedureCode_.abrv === "B4155");
            if (!this.isMasterPatient && isEnteral && itemType) {
                _.extend(tempItem, { itemMls: 1, itemCals: product.calsPerMl });
            }

            const response = await this.pageViewStore.facilityOrderTemplateItemService.createAdditionalItemsNewFlow(
                {
                    facilityOrderId: this.facilityOrder.id,
                    facilityOrderItem: tempItem,
                    facilityOrderItems: facilityOrderTemplateItems.filter((i) => i.product).map((i) => { return { product: i.product, productId: i.productId, procedureCode: i.procedureCode, importActionId: i.importActionId }; }),
                    subCategoryId: facilityOrderTemplate.subCategoryId,
                    clinicalStatusId: facilityOrderTemplate.clinicalStatusId,
                    isMasterPatient: this.isMasterPatient
                }
            );

            if (refreshTemplates || (tempItem.product.innerCannulaId && facilityOrderTemplate.linkedTemplateId == null)) {
                await this.pageViewStore.fetchFacilityOrderTemplatesByPatient(this.facilityOrderPatient.patientId);
            }

            this.addItem(facilityOrderTemplateItems, response, index, facilityOrderTemplate);

            if (!this.isMasterPatient && isEnteral && itemType) {
                index = facilityOrderTemplateItems.indexOf(facilityOrderTemplateItems.slice(index).find(i => i.productId == tempItem.productId));
                this.openFacilityOrderTemplateItemNewFlowCalculationModal(facilityOrderTemplate.id, facilityOrderTemplateItems, index, false, false);
            }
        }
    }

    @action.bound
    async addItem(facilityOrderTemplateItems, items, index, facilityOrderTemplate) {
        this.showTemplateChangeWarning(facilityOrderTemplate);

        facilityOrderTemplateItems.splice(index);
        _.each(items, i => {
            facilityOrderTemplateItems.push({
                id: i.id,
                note: i.note,
                product: i.product,
                productId: i.productId,
                // procedureCode: i.procedureCode,
                // mlph: i.mlph,
                // frequency: i.frequency,
                // itemCals: i.itemCals,
                // itemMls: i.itemMls,
                templateQuantity: i.templateQuantity,
                orderQuantity: i.orderQuantity,
                importActionId: i.importActionId,
                importDetailStatusId: i.importDetailStatusId,
                facilityOrderTemplateId: facilityOrderTemplate.id,
            });
        });
    }

    @action.bound
    editItem(facilityOrderTemplateItem, value, propertyName) {
        facilityOrderTemplateItem[propertyName] = value;
        if (propertyName === "templateQuantity") {
            facilityOrderTemplateItem["orderQuantity"] = value
        }
    }

    @action.bound
    async updateItem(
        facilityOrderTemplateItem,
        facilityOrderTemplate,
        isNote,
        isTemplateQuantityUpdate = false
    ) {

        if (Number.isNaN(facilityOrderTemplateItem.templateQuantity)  || facilityOrderTemplateItem.templateQuantity === '' || facilityOrderTemplateItem.templateQuantity === null || facilityOrderTemplateItem.templateQuantity === undefined) {
            facilityOrderTemplateItem.templateQuantity = 0;
        }
        if (Number.isNaN(facilityOrderTemplateItem.orderQuantity) ||facilityOrderTemplateItem.orderQuantity === '' || facilityOrderTemplateItem.orderQuantity === null || facilityOrderTemplateItem.orderQuantity === undefined) {
            facilityOrderTemplateItem.orderQuantity = 0;
        }

        if (facilityOrderTemplateItem.templateQuantity == facilityOrderTemplateItem.lastTemplateQuantity &&
            facilityOrderTemplateItem.orderQuantity == facilityOrderTemplateItem.lastOrderQuantity &&
            facilityOrderTemplateItem.note == facilityOrderTemplateItem.lastNote) {
            return;
        }

        if (facilityOrderTemplateItem.orderQuantity < facilityOrderTemplateItem.sendSeparatelyQty) {
            this.rootStore.notificationStore.error("An SS has already been applied to this item. The sales order qty cannot be lower than the SS qty.");
            facilityOrderTemplateItem.orderQuantity = facilityOrderTemplateItem.lastOrderQuantity;
            facilityOrderTemplateItem.templateQuantity = facilityOrderTemplateItem.lastTemplateQuantity;
            return;
        }

        this.disabledPatient = true;
        if (facilityOrderTemplateItem.templateItemId && facilityOrderTemplateItem.importActionId != this.pageViewStore.deleteImportActionId) {
            facilityOrderTemplateItem.importActionId = this.pageViewStore.updateImportActionId;
        }

        if ((isNote && facilityOrderTemplateItem.lastNoteValue != facilityOrderTemplateItem.note) || (isTemplateQuantityUpdate && facilityOrderTemplateItem.lastTemplateQuantityValue != facilityOrderTemplateItem.templateQuantity)) {
            this.showTemplateChangeWarning(facilityOrderTemplate);
            facilityOrderTemplateItem.lastTemplateQuantityValue = facilityOrderTemplateItem.templateQuantity;
            facilityOrderTemplateItem.lastNoteValue = facilityOrderTemplateItem.note;
        }

        if (isNote) {
            await this.pageViewStore.facilityOrderTemplateItemService.newFlowUpdate(facilityOrderTemplateItem);

            const initial = facilityOrderTemplateItem.facilityOrderTemplateItemInitial;
            const currentNote = facilityOrderTemplateItem.note != null ? facilityOrderTemplateItem.note : '';
            const initialNote = initial && initial.note != null ? initial.note : '';

            if (initial && currentNote !== initialNote) {
                if (!facilityOrderTemplateItem.isNoteChanged) {
                    facilityOrderTemplateItem.isNoteChanged = true;
                }
            }
            else {
                facilityOrderTemplateItem.isNoteChanged = false;
            }
            facilityOrderTemplateItem.lastNote = facilityOrderTemplateItem.note;
        }
        else {
            let result = await this.pageViewStore.facilityOrderTemplateItemService.newFlowUpdate(facilityOrderTemplateItem);
            if (result) {
                facilityOrderTemplateItem.lastTemplateQuantity = facilityOrderTemplateItem.templateQuantity;
                facilityOrderTemplateItem.lastOrderQuantity = facilityOrderTemplateItem.orderQuantity;
                facilityOrderTemplateItem.lastNote = facilityOrderTemplateItem.note;

                facilityOrderTemplate.isDifferentQty = facilityOrderTemplate.facilityOrderTemplateItems.some(x => x.templateQuantity != x.orderQuantity);
                await this.changeFacilityOrderTemplateStatus([facilityOrderTemplate.id]);

                if (facilityOrderTemplateItem.facilityOrderTemplateItemInitial && facilityOrderTemplateItem.templateQuantity != facilityOrderTemplateItem.facilityOrderTemplateItemInitial.templateQuantity) {
                    if (!facilityOrderTemplateItem.isTemplateQuantityChanged) {
                        facilityOrderTemplateItem.isTemplateQuantityChanged = true;
                    }
                }
                else
                    facilityOrderTemplateItem.isTemplateQuantityChanged = false;

                if (facilityOrderTemplateItem.facilityOrderTemplateItemInitial && facilityOrderTemplateItem.orderQuantity != facilityOrderTemplateItem.facilityOrderTemplateItemInitial.orderQuantity) {
                    if (!facilityOrderTemplateItem.isOrderQuantityChanged) {
                        facilityOrderTemplateItem.isOrderQuantityChanged = true;
                    }
                }
                else
                    facilityOrderTemplateItem.isOrderQuantityChanged = false;
            }
        }

        this.isQtyChange = true;
        this.isQtyChange = false;

        this.disabledPatient = false;
    }

    @action.bound
    async changeFacilityOrderTemplateStatus(facilityOrderTemplateIds, setResponseData = true) {
        if (this.selectedStatusAbrv !== "discharge") {
            let facilityOrderTemplates = this.facilityOrderTemplates.filter(item => facilityOrderTemplateIds.some(id => id === item.id) && item.templateId);
            if (facilityOrderTemplates && facilityOrderTemplates.some(item => item.id)) {
                let response = await this.pageViewStore.facilityOrderTemplateService.changeTemplateStatus(facilityOrderTemplates.map(item => item.id));
                if (setResponseData && response && response.data && response.data.item && response.data.item[0]) {
                    for (const item of response.data.item) {
                        if (this.facilityOrderTemplates.find(x => x.id === item.id)) {
                            this.facilityOrderTemplates.find(x => x.id === item.id).newFlowUSIntakeStatusId = response.data.item[0].newFlowUSIntakeStatusId;
                            this.facilityOrderTemplates.find(x => x.id === item.id).newFlowStatusId = response.data.item[0].newFlowStatusId;
                        }
                    }
                }
            }
        }
        this.isQtyChange = true;
        this.isQtyChange = false;
    }

    @action.bound
    openFacilityOrderTemplateItemNewFlowCalculationModal(
        facilityOrderTemplateId,
        facilityOrderTemplateItems,
        index,
        showWarningModal = true,
        changeStatus = true
    ) {
        let facilityOrderTemplate = this.facilityOrderTemplates.find(item => item.id === facilityOrderTemplateId);
        this.pageViewStore.facilityOrderTemplateItemNewFlowCalculationModal.open({
            facilityOrderTemplateItem: facilityOrderTemplateItems[index],
            facilityOrderTemplate: facilityOrderTemplate,
            isUSIntakeNewFlow: true,
            facilityOrderId: this.facilityOrder.id,
            isUpdate: true,
            showWarningModal: showWarningModal,
            showTemplateChangeWarning: () => this.showTemplateChangeWarning(facilityOrderTemplate),
            changeFacilityOrderTemplateStatus: () => changeStatus ? this.changeFacilityOrderTemplateStatus([facilityOrderTemplate.id]) : {}
        });
    }

    @action.bound
    async deleteFacilityOrderTemplateItem(facilityOrderTemplateItems, index, facilityOrderTemplateId) {
        const skipEnabling = this.disabledPatient;
        this.disabledPatient = true;

        if (this.facilityOrderPatient.isNewPatient && this.facilityOrderTemplates.length == 1 && facilityOrderTemplateItems.length == 1) {
            let params = { facilityOrderId: this.facilityOrder.id, patientId: this.patient.id, rpp: 2, fields: "id" };
            if (this.facilityOrder.isEnteralWeek) {
                params = _.extend(params, {
                    itemCategoryIds: [this.pageViewStore.enteralItemCategoryId]
                });
            }
            var response = (await this.pageViewStore.facilityOrderTemplateService.find(params)).data.item;
            if (response.length == 1) {
                this.pageViewStore.facilityOrderTemplateItemNewFlowDeleteQuestionModal.open({
                    deleteItem: () => this.deleteItem(facilityOrderTemplateItems, index, facilityOrderTemplateId, false),
                    deletePatient: () => this.deleteItem(facilityOrderTemplateItems, index, facilityOrderTemplateId, true)
                });
                if (!skipEnabling) this.disabledPatient = false;
                return;
            }
        }

        if (facilityOrderTemplateItems[index].templateItemId) {
            await this.setImportAction(facilityOrderTemplateId, facilityOrderTemplateItems[index], 'delete');
        }
        else {
            await this.deleteItem(facilityOrderTemplateItems, index, facilityOrderTemplateId, true);
            this.changeFacilityOrderTemplateStatus([facilityOrderTemplateId]);
            this.showTemplateChangeWarning(this.facilityOrderTemplates.find(i => i.id === facilityOrderTemplateId));
        }

        if (!skipEnabling) this.disabledPatient = false;
    }

    @action.bound
    async deleteItem(facilityOrderTemplateItems, index, facilityOrderTemplateId, deleteTemplate) {
        const isNewProduct = facilityOrderTemplateItems[index].product != null;
        if (isNewProduct) {
            const facilityOrderLinkedTemplateId = this.facilityOrderTemplates.find(i => i.id === facilityOrderTemplateId).linkedTemplateId;
            const isInnerCannula = facilityOrderTemplateItems[index].product.innerCannulaId != null;

            try {
                await this.pageViewStore.facilityOrderTemplateItemService.newDelete(facilityOrderTemplateItems[index]);
            }
            catch (ex) {
                if (ex && ex.data.includes("FK_InventoryCalculationCutback_FacilityOrderTemplateItem")) {
                    this.rootStore.notificationStore.error("Template item cannot be deleted because it is included in the Inventory Calculation.");
                }
                else {
                    this.rootStore.notificationStore.error("An unexpected error occurred while trying to delete the item.");
                }
                return;
            }

            if (facilityOrderLinkedTemplateId && isInnerCannula) {
                await this.pageViewStore.fetchFacilityOrderTemplatesByPatient(this.facilityOrderPatient.patientId, true);
            }

        }
        facilityOrderTemplateItems.splice(index, 1);
        if (deleteTemplate && facilityOrderTemplateItems.length === 0) {
            return await this.deleteTemplate(facilityOrderTemplateId);
        }

        if (isNewProduct && this.facilityOrderTemplates.find(i => i.id === facilityOrderTemplateId)) {
            this.setDifferentQty(this.facilityOrderTemplates.find(i => i.id === facilityOrderTemplateId), "IsDifferentQty");
        }
    }

    @action.bound
    async setImportActionToDeleteAndAddItem(item, facilityOrderTemplateItems, index, facilityOrderTemplateId) {
        this.disabledPatient = true;
        try {
            if (item.importActionId === this.pageViewStore.deleteImportActionId) {
                await this.setImportAction(facilityOrderTemplateId, item, "update")
            }
            else {
                await this.deleteFacilityOrderTemplateItem(facilityOrderTemplateItems, index, facilityOrderTemplateId)
                this.addEmptyItem(facilityOrderTemplateId);
            }
        }
        catch (err) {
            this.rootStore.notificationStore.error("FACILITY_ORDER_TEMPLATE_ITEM.EDIT.DELETE_ERROR");
        }
        this.disabledPatient = false;
    }

    @action.bound
    async setImportAction(facilityOrderTemplateId, facilityOrderTemplateItem, action) {
        const skipEnabling = this.disabledPatient;
        this.disabledPatient = true;

        facilityOrderTemplateItem.importActionId = this.lookups.importAction.find(x => x.abrv === action).id;
        await this.pageViewStore.facilityOrderTemplateItemService.newFlowUpdate(facilityOrderTemplateItem);

        if (this.facilityOrderTemplates.find(i => i.id === facilityOrderTemplateId)) {
            this.setDifferentQty(this.facilityOrderTemplates.find(i => i.id === facilityOrderTemplateId), "IsDifferentQty");
        }

        this.changeFacilityOrderTemplateStatus([facilityOrderTemplateId]);
        this.showTemplateChangeWarning(this.facilityOrderTemplates.find(i => i.id === facilityOrderTemplateId));
        if (!skipEnabling)
            this.disabledPatient = false;
    }

    @action.bound
    async activateTemplate(facilityOrderTemplateId) {
        this.disabledPatient = true;
        if (this.facilityOrderPatient.eligibilityStatusId != null && (await this.pageViewStore.hasAnyTemplateInProgress(this.patient.id))) {
            await this.pageViewStore.facilityOrderTemplateService.activateFacilityOrderTemplate({ id: facilityOrderTemplateId, facilityOrderPatientId: this.facilityOrderPatient.id, eligibilityStatusId: this.facilityOrderPatient.eligibilityStatusId });
            await this.pageViewStore.fetchFacilityOrderTemplatesByPatient(this.facilityOrderPatient.patientId, true);
        }
        else {
            await this.openFacilityOrderTemplateNewFlowUSIntakeTemplateActivationModal(facilityOrderTemplateId);
        }
        this.disabledPatient = false;
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakeTemplateActivationModal(facilityOrderTemplateId) {
        let facilityOrderTemplate = this.facilityOrderTemplates.find((item) => item.id === facilityOrderTemplateId);
        this.pageViewStore.facilityOrderTemplateNewFlowUSIntakeTemplateActivationModal.open({
            facilityOrderTemplate: facilityOrderTemplate,
            facilityOrderPatient: this.facilityOrderPatient,
            patient: this.patient,
            fetchPatientTemplates: async () => await this.pageViewStore.fetchFacilityOrderTemplatesByPatient(this.facilityOrderPatient.patientId, true, true)
        });
    }

    @action.bound
    async unreviewDischargeTemplates(facilityOrderTemplateId) {
        this.disabledPatient = true;
        this.saveTemplates(facilityOrderTemplateId, false);
        this.disabledPatient = false;
    }

    @action.bound
    changeItemsVisibility(facilityOrderTemplate) {
        facilityOrderTemplate.itemsVisible = !facilityOrderTemplate.itemsVisible;
    }
}
export default FacilityOrderPatientNewFlowUSIntakePreviewViewStore;
